import homeTemplate from "../templates/pages/home.html?raw";
import NavBar from "../sections/navbar"
import { Page } from "./base";
import Footer from "../sections/footer";

export default class HomePage extends Page {
    constructor() {
      super(homeTemplate);
      this.loadPage();
    }

    public async loadPage(): Promise<void> {
      super.init();
      new NavBar();
      new Footer();
    }
  }
